<template>
  <b-jumbotron header="404" lead="Denne nettsiden finnes ikke!"> </b-jumbotron>
</template>

<script>
export default {
  name: "NotFound",
};
</script>
